import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLOR, SIZE, FONT_FAMILY } from '../../utils/constants.js';

const Content = styled.div`
    display: flex;
    float: ${props => props.float ? props.float : 'left'};
    margin: ${props => props.margin ? props.margin : '0 0'};
`;

const Span = styled.span`
    color: ${ props => props.text_color ? props.text_color : COLOR.black};
    font-family: ${ props => props.font_family ? props.font_family : FONT_FAMILY.antipastoPro};
    /* !important needed: materialize.css sets font-size on [type="checkbox"] + span:not(.lever)
       with higher specificity than this single styled-components class. */
    font-size: ${ props => props.text_size ? props.text_size : SIZE.body} !important;
`;

const Checkbox = (props) => {

    const onCheckboxClicked = () => {
        props.onChange(!props.checked);
    };

    return (
        <Content
            margin={props.margin}
            float={props.float}>
            <label>
                <input
                    id={props.id}
                    name={props.name}
                    type='checkbox'
                    value={props.value}
                    checked={props.checked}
                    onChange={onCheckboxClicked} />
                <Span text_size={props.text_size} text_color={props.text_color} font_family={props.font_family}>{props.children}</Span>
            </label>
        </Content>
    );
}

Checkbox.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    checked: PropTypes.bool,
    value: PropTypes.string,
    text_size: PropTypes.string,
    text_color: PropTypes.string,
    font_family: PropTypes.string,
    margin: PropTypes.string,
    float: PropTypes.string,
    onChange: PropTypes.func
}

export default Checkbox;
